if (!Array.chunk) {
    Array.chunk = function (array, chunkSize) {
        let copy = array.slice();
        let chunkedArray = [];
        while (copy.length > 0) {
            chunkedArray.push(copy.splice(0, chunkSize));
        }
        return chunkedArray;
    }
}